$(document).on('click', '#CartDrawer product-complementary .button', function (event) {
 if (window.clarity) {
                // Trigger the event with a custom name
                window.clarity("event", "Complementary_Click");
                console.log("✅ Clarity Event Sent: Complementary_Click");
            } else {
                console.log("⚠️ Clicked, but Clarity is not loaded.");
            }
})
  var params = new URLSearchParams(window.location.search);
  var id = params.get('mediaId') || params.get('media');
if(id) {
setTimeout(function() {

  var selector = 'button[data-media-id="' + id + '"]';
 $(selector).first().trigger('click');
  }, 1000); 
}
$(function() {
 $.getJSON('/cart.js', function(cart) {
   if(cart.discount_codes.some(dc => dc.code.includes("FreeShipThursday"))) {

       $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: {
      attributes: {
        freeShip: true,
      }
    },
    success: function(cart) {
 
    }
  // });
   })
 } else {
    
       $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: {
      attributes: {
        freeShip: null,
        off10: null,
        freeGiftVip: null,
      }
    },
    success: function(cart) {
      console.log('Cart attribute freegift:', cart.attributes.freegift);
    }
  // });
   }) 
 }

});
})



$('.discount-filter').click(function() {
  $('.facet-wrapper button').click();
$('.details').not('[data-index="drawer-filter.p.tag"]').attr('open', false).attr('aria-expanded', 'false');
  
$('.details').not('[data-index="drawer-filter.p.tag"]').find('details__content').attr('style', function(i, style) {
        return style.replace('opacity: 1', 'opacity: 0').replace('opacity: 0', 'opacity: 0');
    });
  $('.details[data-index="drawer-filter.p.tag"]').attr('open', true).attr('aria-expanded', 'true');

  
})

$('.quick-add').click(function() {
   var newContent = $(this).closest('.product-card--card').find('.price.regios-dopp-generic-price-container').clone();
  setTimeout(function() {
$('quick-view[active]').find('.price.regios-dopp-generic-price-container').replaceWith(newContent);
  }, 4000); 

})
$('.size-filter').click(function() {
  $('.facet-wrapper button').click();
$('.details').not('[data-index="drawer-filter.v.option.size"]').attr('open', false).attr('aria-expanded', 'false');
  
$('.details').not('[data-index="drawer-filter.v.option.size"]').find('details__content').attr('style', function(i, style) {
        return style.replace('opacity: 1', 'opacity: 0').replace('opacity: 0', 'opacity: 0');
    });
  $('.details[data-index="drawer-filter.v.option.size"]').attr('open', true).attr('aria-expanded', 'true');

  
})

$('.color-filter').click(function() {
  $('.facet-wrapper button').click();
$('.details').not('[data-index*="color"]').attr('open', false).attr('aria-expanded', 'false');
$('.details').not('[data-index*="color"]').find('details__content').attr('style', function(i, style) {
        return style.replace('opacity: 1', 'opacity: 0').replace('opacity: 0', 'opacity: 0');
    });
    $('.details[data-index*="color"]').attr('open', true).attr('aria-expanded', 'true');
  
})








document.addEventListener('DOMContentLoaded', function() {

    // Size Change Event
    document.querySelectorAll('input[name="Size"]').forEach(function(input) {
      if(input) {
        input.addEventListener('change', function() {
             const inventory = parseInt(this.getAttribute('inventory'));
            const size = this.getAttribute('modal-size');
            const height = this.getAttribute('modal-height');
            const name = this.getAttribute('modal-name');
            document.querySelector('.modal-name').textContent = name;
            document.querySelector('.modal-height').textContent = height;
            document.querySelector('.modal-size').textContent = size;
            if (name.length > 0) {
                setTimeout(function() {
                    document.querySelector('.product__media.selected .modal-info').classList.remove('hideMe');
                }, 90);
            }
        });
      }
    });

    // Calculate Discount Percentage
  if(document.querySelector('.price-affrim-container .price__sale')) {
    let regularPriceText = document.querySelector('.price-affrim-container .price__sale').textContent.replace('$', '').trim();
    let regularPrice = parseFloat(regularPriceText);
    let salePriceText = document.querySelector('.price-affrim-container .price__regular span').textContent.replace('$', '').trim();
    let salePrice = parseFloat(salePriceText);

    if( document.querySelector('.price-affrim-container  .final-sale-tag')) {
        if (regularPrice > salePrice) {
            let discountPercentage = ((regularPrice - salePrice) / regularPrice) * 100;
            discountPercentage = discountPercentage.toFixed(2);
            if (discountPercentage >= 40) {
                document.querySelector('.price-affrim-container .final-sale-tag').classList.remove('hideMe');
            } else {
                document.querySelector('.price-affrim-container .final-sale-tag').classList.add('hideMe');
            }
        } else {
            document.querySelector('.price-affrim-container .final-sale-tag').classList.add('hideMe');
        }
    }
  }

    // Scroll Events
    window.addEventListener('scroll', function() {
        const collectionContent = document.querySelector('.collection__content');
        if (collectionContent && document.querySelector('.facet-sticky') ) {
            const mnopTop = collectionContent.getBoundingClientRect().top;
            if (mnopTop <= 0) {
                document.querySelector('.facet-sticky').classList.add('visible');
            } else {
                document.querySelector('.facet-sticky').classList.remove('visible');
            }
        }

        const element = document.querySelector('.mobile-dock');
        const intercomFrame = document.querySelector('.intercom-launcher');
        const intercomFrameIframe = document.querySelector('.intercom-launcher-frame');

        if (element && window.innerWidth < 700 && intercomFrame && intercomFrameIframe ) {
            const style = getComputedStyle(element);
            if (style.transform === 'none' || style.transform === 'matrix(1, 0, 0, 1, 0, 0)') {
                if (intercomFrame) intercomFrame.classList.add('hideMe123');
                if (intercomFrameIframe) intercomFrameIframe.classList.add('hideMe123');
            } else {
                if (intercomFrame) intercomFrame.classList.remove('hideMe123');
                if (intercomFrameIframe) intercomFrameIframe.classList.remove('hideMe123');
            }
        }
    });

    // Cart Drawer Button Resize Event


    // Tolstoy Widget
    window.tolstoySettings = {
        loadHidden: true,
    };

    // Add to Wishlist




    // Show Wishlist Button After Delay
setTimeout(function() {
  document.querySelectorAll('.swym-button.swym-add-to-wishlist-view-product.swym-heart')
    .forEach(function(el) {
      el.style.display = 'block';
    });
}, 2000);

    // Image Swatch Hover
  
});

// Use a static parent container if possible, otherwise use document
$(document).on('mouseenter', '.product-card .color-swatch', function() {
    const $swatch = $(this);
    const newImageSrc = $swatch.attr('img');
    const $parentCard = $swatch.closest('.card.product-card');
    const $mainImg = $parentCard.find('.media.is-selected img').first();

    // Store the original src on the image itself so it's not overwritten 
    // by other swatches in a global variable
    if (!$mainImg.data('original-src')) {
        $mainImg.data('original-src', $mainImg.attr('src'));
    }

    $mainImg.attr('src', newImageSrc);
    $mainImg.attr('srcset', newImageSrc);

}).on('mouseleave', '.product-card .color-swatch', function() {
    const $swatch = $(this);
    const $parentCard = $swatch.closest('.card.product-card');
    const $mainImg = $parentCard.find('.media.is-selected img').first();
    
    const originalSrc = $mainImg.data('original-src');
    
    if (originalSrc) {
        $mainImg.attr('src', originalSrc);
        $mainImg.attr('srcset', originalSrc);
    }
});

// Works for dynamically added buttons
$(document).on('click', '.add-to-wishlist', function (event) {
  event.preventDefault();
  // alert('wishlist button clicked!');

  const $wishlistView = $(this).closest('wishlist-view');
  if ($wishlistView.length === 0) return;

  const variantId   = $wishlistView.find('form input[name=id]').val();
  const productId   = $wishlistView.find('form input[name=product-id]').val();
  const urlField    = $wishlistView.find('form input[name=url]').val() || '';
  const imgSrc      = $wishlistView.find('.product__media img').attr('src') || '';
  const productTitle= $wishlistView.find('form input[name=title]').val() || '';

  // Build absolute URL if needed
  const du = /^https?:\/\//i.test(urlField) ? urlField : `https://www.sweetlegs.ca${urlField}`;

  const product = {
    epi: parseInt(variantId, 10),
    empi: parseInt(productId, 10),
    du,
    et: 4,
    uri: "https://www.sweetlegs.ca/?&_ab=0&_fd=0&_sc=1",
    dt: "Canadian designed leggings & women's wear | SweetLegs",
    ct: "",
    rc: "default",
    type: "product-variant"
  };

  if (window._swat && window._swat.addToWishList) {
    window._swat.addToWishList(
      product,
      function success(response) {
        const content = `
          <a href="/pages/swym-wishlist">
            <div class="swym-product-tile">
              <button class="swym-close-btn swym-is-button" aria-label="Close Notification">
                <span class="swym-icon"></span>
              </button>
              <img class="swym-image" src="${imgSrc}" alt="">
              <div class="swym-details-container">
                <div class="swym-details" role="alert">
                  <span class="swym-emphasis">${productTitle}</span> has been added to 
                  <span class="swym-emphasis">1 list</span> successfully.
                </div>
              </div>
            </div>
          </a>`;

        if (window._swat.ui?.uiRef?.showSuccessNotification) {
          window._swat.ui.uiRef.showSuccessNotification({ message: content });
        }

        // Close the modal/sheet
        $wishlistView.removeAttr('open').removeAttr('active').attr('aria-modal', false);
      },
      function fail(error) {
        $wishlistView.removeAttr('open').removeAttr('active').attr('aria-modal', false);
        // Optionally log error
        // console.error('Swym addToWishList failed:', error);
      }
    );
  } else {
    // Fallback if swym not ready
    // console.warn('Swym _swat not available');
  }
});
